import { defineComponent as _defineComponent } from 'vue'
import { onBeforeUnmount, ref, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'BreadcrumbName',
  props: {
    name: null,
    link: null
  },
  setup(__props: any) {



const textRef = ref<HTMLElement | null>(null)
const isTruncated = ref(false)

const updateTruncated = () => {
  const el = textRef.value
  isTruncated.value = el ? el.scrollWidth > el.clientWidth : false
}

// 表示幅やフォント読み込みで幅が変わっても省略判定を追従させる。
// link の有無で監視対象の要素が入れ替わるため textRef の変化にも追随する。
const resizeObserver = new ResizeObserver(updateTruncated)
watch(
  textRef,
  (el, prev) => {
    if (prev) resizeObserver.unobserve(prev)
    if (el) resizeObserver.observe(el)
  },
  { immediate: true, flush: 'post' }
)

onBeforeUnmount(() => resizeObserver.disconnect())

return { __sfc: true,textRef, isTruncated, updateTruncated, resizeObserver }
}

})